import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,_vm._l((_vm.game.players),function(player){return _c(VCard,{key:player.id},[_c('sn-player-panel',{attrs:{"player":player,"game":_vm.game},on:{"show":function($event){return _vm.$emit('show', player.id)},"pass":function($event){return _vm.$emit('pass')}}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }